import {
  AdjustmentsHorizontalIcon,
  ArrowDownIcon,
  ArrowUpIcon,
  CalendarIcon,
  ChevronDownIcon,
} from "@heroicons/react/20/solid";
import React from "react";
import { convertToCurrencyFormat } from "../../shared/utility";

interface Stat {
  name: string;
  subtitle: string | null;
  stat: string;
  previousStat: string;
  change: string;
  changeType: string;
  nameColor: string;
  statColor: string;
}

interface StatsProps {
  title: string;
  loading: boolean;
  statsSummaries: Stat[];
}

const StatsComponents: React.FC<StatsProps> = ({
  title,
  loading,
  statsSummaries,
}) => {
  return (
    <div>
      <div className="flex">
        <div>
          <h3 className="text-3xl font-semibold text-gray-900">{title}</h3>
          <h3 className="text-base font-normal text-gray-600">
            Here's an overview of today
          </h3>
        </div>
      </div>
      <dl className="mt-2 grid grid-cols-1 divide-y divide-gray-200 overflow-hidden rounded-xl bg-white shadow md:grid-cols-4 md:divide-x md:divide-y-0">
        {statsSummaries.map((item) => (
          <div key={item.name} className="p-4">
            <dt className={`text-base font-semibold ${item.nameColor}`}>
              {item.name}
            </dt>
            <dd className="mt-1 flex items-baseline gap-2">
              <div
                className={`flex items-baseline text-2xl font-semibold flex-grow ${item.statColor} mr-2`}
              >
                {convertToCurrencyFormat(item.stat)}
              </div>
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
};

export default StatsComponents;
